import AdtechStackCore from "@almamedia/amr-adtech-stack/lib/core/ats";
import { XandrAdService } from "@almamedia/amr-adtech-stack/lib/services/ads";
import { AlmaB2CCmpService } from "@almamedia/amr-adtech-stack/lib/services/cmp";
import { DataLayerService } from "@almamedia/amr-adtech-stack/lib/services/dataLayer";
import AlmaDmpService from "@almamedia/amr-adtech-stack/lib/services/dmp/almadmp";
import { GravitoService } from "@almamedia/amr-adtech-stack/lib/services/gravito";
import { MetaApiService } from "@almamedia/amr-adtech-stack/lib/services/meta-api";
import {
  ContentSystem,
  SiteId,
} from "@almamedia/amr-adtech-stack/lib/services/meta-api/query";
import NativeAdsService from "@almamedia/amr-adtech-stack/lib/services/native/native-ads";
import BrandsafetyService from "@almamedia/amr-adtech-stack/lib/services/brandsafety/almabrandsafety";
import LazyloadService from "@almamedia/amr-adtech-stack/lib/services/lazyload/lazyload";
import { PrebidService } from "@almamedia/amr-adtech-stack/lib/services/prebid/prebid";
import nativeAds, { SiteNativeTemplate } from "./native/native";
import ads from "./ads/ads";
import dmp from "./dmp/dmp";
import lazyload from "./lazyload/lazyload";
import dataLayer, { ICustomVariables } from "./data-layer/data-layer";
import prebid from "./prebid/prebid";

declare global {
  interface Window {
    showCMPV2Modal?: boolean;
  }
}

async function initStack(): Promise<void> {
  if (window?.showCMPV2Modal === false) {
    return;
  }

  const atsCore = new AdtechStackCore<ICustomVariables, SiteNativeTemplate>(
    "iltalehti",
    process.env.SITE_VERSION ?? "unknown"
  );
  await atsCore.start();

  atsCore.services.almaCmpService = new AlmaB2CCmpService({}, atsCore);

  atsCore.services.gravitoService = new GravitoService(
    { enabled: true },
    atsCore
  );
  await atsCore.services.gravitoService.bootstrapService();

  atsCore.services.dataLayerService = new DataLayerService<
    ICustomVariables,
    SiteNativeTemplate
  >(dataLayer, atsCore);

  atsCore.services.lazyloadService = new LazyloadService(lazyload, atsCore);
  atsCore.services.lazyloadService.initLazyloader();

  atsCore.services.metaApiService = new MetaApiService(
    {
      enabled: true,
      defaults: {
        siteId: "il" as SiteId,
        contentSystem: ContentSystem.OpenContent,
        timeout: 1000,
      },
    },
    atsCore
  );

  atsCore.services.brandsafetyService = new BrandsafetyService(
    {
      ads: {
        enabled: true,
        rawSemanticsMin: 10,
        rawSemanticsMax: 100,
      },
    },
    atsCore
  );

  atsCore.services.almaDmpService = new AlmaDmpService(dmp, atsCore);
  await atsCore.services.almaDmpService.init();

  atsCore.services.nativeAdsService = new NativeAdsService(nativeAds, atsCore);

  atsCore.services.prebidService = new PrebidService(prebid, atsCore);

  atsCore.services.adsService = new XandrAdService(ads, atsCore);
  await atsCore.services.adsService.bootstrapService();
}

initStack();
